import CommentTabsComponent from '@root/core/components/CommentTabs';
import ImportBox from '@root/modules/Sellers/Import/components/ImportBox';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import commentService from '@root/core/components/CommentTabs/commentService';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import AttachDown from '@root/modules/Warehouse/Inquiry/components/attachment/AttachDown';
import Comment from '@root/modules/Warehouse/Inquiry/components/comment';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import CheckPoint from '@root/modules/Warehouse/Inquiry/components/shipping/CheckPoint';
import ShipmentMethod from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethod';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import {
  Card,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  message,
  Row,
  Select,
  Table
} from 'antd';
import { Option } from 'antd/lib/mentions';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import '../../../../../styles/pages/seller/_return-detail.scss';
import Recipient from '../../components/Recipient/Recipient';
import { DataType } from '../../interface';
import ReturnDetailOrder from './ReturnDetailOrder';
import ReturnDetailStock from './ReturnDetailStock';
import {
  CommentGroup,
  CommentList,
  CommentTabs,
  CommentType,
  CreateComment
} from '@root/core/components/CommentTabs/interface';
import { ReturnStatus } from '@root/modules/Sellers/Shipping/enum';
import Popup from '@root/core/components/Popup';

const ReturnDetailPage = () => {
  const { productId }: any = useParams();
  const [productComment, setProductComment] = useState([] as any);
  const [productReturn, setProductReturn] = useState([] as any);
  const [productOrder, setProductOrder] = useState([] as any);
  const [recipient, setRecipient] = useState([] as any);
  const [quantity, setQuantity] = useState([] as any);
  const [statusTitle, setStatusTitle] = useState('');
  const [commentList, setCommentList] = useState<CommentList>();
  const [tabs, setTabs] = useState<CommentTabs[]>([]);
  const [openSave, setOpenSave] = useState(false);
  const [returnData, setReturnData] = useState<FormInstance>();
  const [commentAllId, setCommentAllId] = useState(0);
  const [productReturnQuotation, setProductReturnQuotation] = useState(
    [] as any
  );
  const [importId, setImportId] = useState(0);

  const [form] = Form.useForm();

  const BreadcrumbReturn = [
    {
      tittle: '반환/폐기 관리',
      url: ''
    },
    {
      tittle: '반환 조회',
      url: '/admin/seller/return'
    },
    {
      tittle: '반환 상세',
      url: ''
    }
  ];
  const BreadcrumbReturnDisposal = [
    {
      tittle: '반환/폐기 관리',
      url: ''
    },
    {
      tittle: '폐기 조회',
      url: '/admin/seller/return-disposal'
    },
    {
      tittle: '폐기 상세',
      url: ''
    }
  ];
  const listStatus = [
    {
      code: 'Request',
      name: '배송 요청'
    },
    {
      code: 'Inprogress',
      name: '배송중'
    },
    {
      code: 'Completed',
      name: '배송 완료'
    }
  ];
  const listStatusDisposal = [
    {
      code: 'Request',
      name: '폐기 요청'
    },
    {
      code: 'Inprogress',
      name: '폐기중'
    },
    {
      code: 'Completed',
      name: '폐기 완료'
    }
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: 'Update Date',
      dataIndex: 'updated_at',
      width: '20%'
    },
    {
      title: 'Courier',
      dataIndex: 'courier'
    },
    {
      title: 'Tracking Number',
      dataIndex: 'trackingNumber'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    }
  ];

  const [breadCrumbUse, setbreadCrumbUse] = useState(BreadcrumbReturn);
  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const history = useHistory();

  useEffect(() => {}, [productOrder]);

  const getDetailReturn = async () => {
    const returnDetail = await ReturnServices.getDetailReturn(productId);
    setRecipient(returnDetail.data);
    switch (returnDetail?.data?.returnType) {
      case 'Import':
        setProductReturnQuotation(returnDetail.data.import.quotation);
        setProductComment(returnDetail.data.import);
        const list: any[] = [];
        const arrData: any[] = returnDetail.data.importProducts.products;
        arrData?.forEach((item: any, index: number) => {
          list.push({
            productName: item.productName,
            width: item.width,
            height: item.height,
            length: item.length,
            demensionUnit: item.demensionUnit,
            weight: item.weight,
            weightUnit: item.weightUnit,
            estimateQuantity: item.estimateQuantity,
            averageMonthSale: item.averageMonthSale,
            sku: item.sku,
            eanUpc: item.eanUpc,
            asin: item.asin,
            packedMethod: item.packedMethod,
            storageMethod: item.storageMethod,
            dangerousGoods: item.dangerousGoods,
            lotProduct: item.lotProduct,
            image: item.image?.url,
            deliveredDate: formatDateTime(item.inventory?.deliveredDt),
            location: item.inventory?.location,
            est: item.inventory?.estimatedQuantity,
            deliveredQuantity: item.inventory?.deliveredQuantity,
            availableQuantity: item.inventory?.availableQuantity,
            // unAvailableQuantity: item.inventory?.unAvailableQuantity,
            unAvailableQuantity:
              (item?.product?.inventory?.deliveredQuantity ?? 0) -
              (item?.product?.inventory?.availableQuantity ?? 0),
            inspectionResult: item.inventory?.inspectionResult,
            returnQuantity: item.returnQuantity
          });
        });
        setProductReturn(list);
        setImportId(returnDetail.data.import.id);
        break;
      case 'Order':
        setProductComment(returnDetail.data.order);
        const products = returnDetail.data?.orderProducts.products || [];
        setProductReturnQuotation(products);
        setQuantity(products);
        setProductOrder(products);

        break;
      case 'Stock':
        setProductComment(returnDetail.data.product);
        break;
    }

    if (returnDetail.data.returnStatus === ReturnStatus.Request) {
      setTabs([
        {
          title: 'Comment',
          type: CommentType.COMMON,
          description: 'Comment from Customer :'
        },
        {
          title: 'Request modify',
          description: 'Reasons for modification from customer :',
          type: CommentType.REQUEST_MODIFY,
          options: []
        },
        {
          title: 'Request delete',
          description: 'Reasons for deletion from Customer :',
          type: CommentType.REQUEST_DELETE,
          options: []
        }
      ]);
    } else {
      setTabs([
        {
          title: 'Comment',
          type: CommentType.COMMON,
          description: 'Comment from Customer :'
        }
      ]);
    }
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
      setLoading(true);
    }
    const comments = await commentService.getComments({
      group: CommentGroup.RETURN_DETAIL,
      itemId: productId
    });
    setCommentList(comments);
    if (showLoading) {
      setLoading(false);
    }
  };

  const onSendComment = async (body: CreateComment, id?: number) => {
    setLoading(true);
    // send comment
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
    setLoading(false);
  };

  const removeRequest = async () => {
    setLoading(true);
    try {
      const result = await ReturnServices.removeReturn(recipient.id);
      if (result?.response?.status === 400) {
        message.error(result?.response?.data?.message?.[0]);
      }

      history.push(
        recipient.processType === 'return'
          ? '/admin/seller/return'
          : '/admin/seller/return-disposal'
      );
    } catch (error: any) {
      message.error(error?.message?.[0]);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setOpenSave(false);
    if (returnData) {
      const body = returnData.getFieldsValue();
      await ReturnServices.updateReturn(recipient.id, {
        ...body,
        comment: body.sellerComment,
        detailReturnAddress: body.detailAddress,
        commentAllId
      });
      await getDetailReturn();
      await getCommentList();
    }
    setCanEdit(false);
    setLoading(false);
  };

  const commentTabsComponent = canEdit ? null : (
    <CommentTabsComponent
      itemId={productId}
      commentGroup={CommentGroup.RETURN_DETAIL}
      tabs={tabs}
      refectComments={getCommentList}
      onSend={onSendComment}
      commentList={commentList!}
      isWarehouseSendCommentFirst
      updateItem={(commentId: number) => {
        setCommentAllId(commentId);
        setCanEdit(true);
      }}
      removeTitle="반환 신청 내용을 삭제 하시겠습니까?"
      removeItem={removeRequest}
    />
  );

  const type = recipient?.returnType;

  useEffect(() => {
    getDetailReturn();
    getCommentList();
  }, []);

  const listCommentReturn: any[] = [productComment];
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname
        .replace('/admin/seller/', '')
        .includes('return-disposal')
    ) {
      setbreadCrumbUse(BreadcrumbReturnDisposal);
      setStatusTitle('폐기 진행 상황');
    } else {
      setbreadCrumbUse(BreadcrumbReturn);
      setStatusTitle('반환 진행 상황');
    }
  }, [location]);

  const defaultValueDataOrder = useMemo(() => {
    return {
      trackingNumber: recipient ? recipient?.trackingNumber : '',
      status: recipient ? recipient?.warehouseReturnStatus : '',
      updated_at: recipient?.warehouseUpdateDate
        ? moment(recipient?.warehouseUpdateDate).utc()
        : null,
      courier: recipient ? recipient?.courier : ''
    };
  }, [recipient]);

  useEffect(() => {
    form.setFieldsValue(defaultValueDataOrder);
  }, [form, defaultValueDataOrder]);

  const dataSource = (): DataType[] => {
    return [
      {
        key: '1',
        updated_at: (
          <Form.Item>
            <Form.Item name={'updated_at'}>
              <DatePicker
                style={{ width: '100%' }}
                className="inputRadious"
                disabled={true}
                format={'YYYY.MM.DD hh:mm:ss A'}
                placeholder="YYYY.MM.DD 00:00:00"
              />
            </Form.Item>
          </Form.Item>
        ),
        courier: (
          <Form.Item
            name={['courier']}
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z\s]*$/),
                message: 'Only English can be entered'
              }
            ]}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
        ),
        trackingNumber: (
          <Form.Item
            name={['trackingNumber']}
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z0-9\s]*$/),
                message: 'Only English can be entered'
              }
            ]}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
        ),
        status: (
          <Form.Item
            name={['status']}
            rules={[
              {
                required: true,
                message: 'Input status!'
              }
            ]}
          >
            <Select className="quantitySelect" disabled={true}>
              <Option value="Inprogress">Inprogress</Option>
              <Option value="Complete">Complete</Option>
            </Select>
          </Form.Item>
        )
      }
    ];
  };

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadCrumbUse} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {type === 'Import' ? (
            <div
              className=""
              style={{
                backgroundColor: 'white',
                padding: '30px 10px',
                borderRadius: '6px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 10px 0',
                  background: 'white',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f0f0'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: 'white',
                    justifyContent: 'space-between'
                  }}
                >
                  <p
                    style={{
                      marginBottom: '0px',
                      fontWeight: 'bold',
                      fontSize: '15px'
                    }}
                  >
                    {recipient?.sellerName ?? ''}{' '}
                  </p>
                  <p
                    style={{
                      marginBottom: '0px',
                      marginLeft: '10px',
                      color: '#747274'
                    }}
                  >
                    {recipient.sellerId} // befoer: seller.id
                  </p>
                </div>
                <p>{formatDateTime(recipient.created_at)}</p>
              </div>
              {canEdit ? (
                <Row style={{ padding: '10px', textAlign: 'end' }}>
                  <Col span={24}>
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => setOpenSave(true)}
                    >
                      저장하기
                    </span>
                  </Col>
                </Row>
              ) : null}
              {productReturn.map((item: any) => {
                return (
                  <DetailsPro
                    productName={item.productName}
                    width={item.width}
                    height={item.height}
                    length={item.length}
                    demensionUnit={item.demensionUnit}
                    weight={item.weight}
                    weightUnit={item.weightUnit}
                    estimateQuantity={item.estimateQuantity}
                    averageMonthSale={item.averageMonthSale}
                    sku={item.sku}
                    eanUpc={item.eanUpc}
                    asin={item.asin}
                    packedMethod={item.packedMethod}
                    storageMethod={item.storageMethod}
                    dangerousGoods={item.dangerousGoods}
                    lotProduct={item.lotProduct}
                    img={item.image}
                  />
                );
              })}

              <div style={{ display: 'flex', marginTop: '15px', gap: '10px' }}>
                <ShipmentMethod
                  shipmentMethod={productReturnQuotation.shipmentMethod}
                  shipmenDetail={productReturnQuotation.shipmentDetail}
                />
                <ShippingPlant
                  shippingPlanEtd={productReturnQuotation.shippingPlanEtd}
                  shippingPlanEta={productReturnQuotation.shippingPlanEta}
                  onChange={() => {}}
                />
                <CheckPoint checkPoint={productReturnQuotation.checkPoint} />
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                {listCommentReturn.map((item: any) => (
                  <>
                    <AttachDown
                      label="Customer’s attachments"
                      documents={item.attachments}
                    />
                    <Comment
                      title="Comment from Customer :"
                      date={moment(item.sellerCommentDate)
                        .utc(true ?? 9)
                        .format('YYYY-MM-DD hh:mm:ss ')}
                      content={item.sellerComment}
                      btnText=""
                    />
                  </>
                ))}
              </div>
              {importId && (
                <ImportBox flag={true} listReturn={productReturn} productId={importId.toString()} />
              )}
              <Recipient
                recipientName={recipient.recipientName}
                recipientPhone={recipient.recipientPhone}
                shippingAddress={recipient.returnAddress}
                quantity={productReturn.returnQuantity ?? 0}
                returnReason={recipient.returnReason}
                statusReturn={
                  location.pathname.includes('return-disposal')
                    ? listStatusDisposal.find(
                        (x) => x.code === recipient.returnStatus
                      )?.name
                    : listStatus.find((x) => x.code === recipient.returnStatus)
                        ?.name
                }
                sellerComment={recipient.comment}
                detailReturnAddress={recipient.detailReturnAddress}
                country={recipient.country}
                postalCode={recipient.postalCode}
                detailReturnAddress2={recipient.detailReturnAddress2}
                state={recipient.state}
                city={recipient.city}
                productReturn={productReturn}
                statusTitle={statusTitle}
                screenName="ReturnImportDetail"
                haveOneQuan
                canEdit={canEdit}
                canUpdate
                onChange={(data: any) => setReturnData(data)}
              />

              {commentTabsComponent}

              {/* <Form
                form={form}
                style={{ margin: 'auto' }}
                initialValues={{
                  trackingNumber: defaultValueDataOrder.trackingNumber,
                  status: defaultValueDataOrder.status,
                  updated_at: defaultValueDataOrder.updated_at
                    ? defaultValueDataOrder.updated_at
                    : '',
                  courier: defaultValueDataOrder.courier
                }}
              >
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={dataSource()}
                  pagination={false}
                />
              </Form> */}
            </div>
          ) : type === 'Stock' ? (
            <ReturnDetailStock
              productComment={productComment}
              recipient={recipient}
              commentTabsComponent={commentTabsComponent}
              statusTitle={statusTitle}
              canEdit={canEdit}
              setOpenSave={setOpenSave}
              onRecipientChange={(data: any) => setReturnData(data)}
            />
          ) : type === 'Order' ? (
            <>
              <ReturnDetailOrder
                recipient={recipient}
                productComment={productComment}
                productOrder={productOrder}
              />
            </>
          ) : (
            ''
          )}
        </Card>
      </div>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openSave}
        textCancel="취소"
        textOk="확인"
        title="저장 하시겠습니까?"
        action_oke={handleUpdate}
        action_cancel={() => setOpenSave(false)}
      />
    </>
  );
};

export default ReturnDetailPage;
